export const gitHubLink = 'https://github.com/vdmrgv/react-scroll-percentage-hook';
export const npmLink = 'https://www.npmjs.com/package/react-scroll-percentage-hook';
